import Footer from "./components/Footer";
import Navb from "./components/Nav";
import Navalt from "./components/Navalt";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  return (
    <>
      {location.pathname == "/" ? <Navb /> : <Navalt />}
      <a
        href="https://wa.me/1234567890"
        className="whatsapp-button animated btn btn-success rounded-circle p-3"
        target="_blank"
        rel="noreferrer"
      >
        <a
          href="https://wa.me/555391425203"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit" }}
        >
          <FaWhatsapp size={50} />
        </a>
      </a>
      <Footer />
    </>
  );
}

export default App;
